import { render, staticRenderFns } from "./starDisplay.vue?vue&type=template&id=a75f107c&"
import script from "./starDisplay.vue?vue&type=script&lang=js&"
export * from "./starDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a75f107c')) {
      api.createRecord('a75f107c', component.options)
    } else {
      api.reload('a75f107c', component.options)
    }
    module.hot.accept("./starDisplay.vue?vue&type=template&id=a75f107c&", function () {
      api.rerender('a75f107c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wDeASB2jwI5H/JS/comp/starDisplay.vue"
export default component.exports